/** GETS-MRO Section 6 tags + removal certificate for MRO workbench. */
export const MRO_COMPONENT_TAGS = [
  { key: 'SERVICEABLE', formNo: 'GETS/TAG/002', label: 'Serviceable tag (green)' },
  { key: 'UNSERVICEABLE', formNo: 'GETS/TAG/003', label: 'Unserviceable tag' },
  { key: 'IDENTIFICATION', formNo: 'GETS/TAG/004', label: 'Identification tag' },
  { key: 'QUARANTINE', formNo: 'GETS/TAG/005', label: 'Quarantine tag' },
  { key: 'SCRAP', formNo: 'GETS/TAG/006', label: 'Scrap tag' },
  { key: 'COMPONENT_HOLDING', formNo: 'GETS/TAG/007', label: 'Component holding tag' },
  { key: 'TOOLS_INACTIVE', formNo: 'GETS/TAG/010', label: 'Tools / equipment inactive (cyan)' },
  { key: 'DO_NOT_OPERATE', formNo: 'GETS/TAG/011', label: 'Do not operate (red hazard)' },
  { key: 'DO_NOT_RECONNECT', formNo: 'GETS/TAG/012', label: 'Do not re-connect (amber hazard)' },
  { key: 'PRESERVATION', formNo: 'GETS/TAG/013', label: 'Preservation tag' },
  { key: 'REPAIRABLE', formNo: 'GETS/TAG/015', label: 'Repairable tag' },
  { key: 'SERVICEABLE_GSE', formNo: 'GETS/TAG/016', label: 'Serviceable tag — GSE (green)' },
  { key: 'UNSERVICEABLE_GSE', formNo: 'GETS/TAG/017', label: 'Unserviceable tag — GSE' },
  {
    key: 'REMOVAL_CERTIFICATE',
    formNo: 'CERTIFICATE',
    label: 'Removal certificate (full history)',
    isCertificate: true
  }
];

export const DEFAULT_MRO_COMPONENT_TAG = 'SERVICEABLE';
